import { render, staticRenderFns } from "./region-input-group.vue?vue&type=template&id=55d7fb85&scoped=true&"
import script from "./region-input-group.vue?vue&type=script&lang=js&"
export * from "./region-input-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d7fb85",
  null
  
)

export default component.exports